<template>
  <div class="stepper">
  <div
    v-for="(step, index) in steps"
    :key="index"
    class="step-wrapper"
  >
    <div class="step-container">
      <div class="circle" :class="getCircleClass(index)">
        <template v-if="index < currentStep">
          <i class="fa fa-check" />
        </template>
        <template v-else>
          {{ index + 1 }}
        </template>
      </div>
      <p class="label" :class="getLabelClass(index)">
        {{ step }}
      </p>
    </div>

    <!-- Linha de conexão -->
    <div
      v-if="index < steps.length - 1"
      class="line"
      :class="{
        complete: index < currentStep - 1,
        gradient: index === currentStep - 1
      }"
    />
  </div>
</div>

</template>

<script>
export default {
  props : {
    steps: Array,
    currentStep: Number,
  },
  methods: {
    getCircleClass(index) {
      if (index < this.currentStep) return 'complete'
      if (index === this.currentStep) return 'active'
      return ''
    },
    getLabelClass(index) {
      if (index < this.currentStep) return 'complete'
      if (index === this.currentStep) return 'active'
      return ''
    }
  }
  
}

</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>
